import React from "react";
import { useIsAuthenticated } from "@azure/msal-react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// Pages
import Dashboard from "./pages/Dashboard";
import Incidents from "./pages/Incidents";
import Changes from "./pages/Changes";
import Licenses from "./pages/Licenses";
import Customers from "./pages/Customers";
import Time from "./pages/Time";
import Customer from "./pages/Customer";
import Invoices from "./pages/invoices";
import Invoice from "./pages/invoice";

// Layouts and components
import Login from "./components/Login";
import SidebarLayout from "./layouts/Sidebar";
import Management from "./pages/Management";
import Projects from "./pages/Projects";
import CustomerProjects from "./pages/CustomerProjects";

const App: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();

  // Kaas

  return (
    <>
      {isAuthenticated ? (
        <Router>
          <Routes>
            <Route element={<SidebarLayout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/incidents" element={<Incidents />} />
              <Route path="/changes" element={<Changes />} />
              <Route path="/licenses" element={<Licenses />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/time" element={<Time />} />
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:name/" element={<CustomerProjects />} />
              <Route path="/customer/:name/" element={<Customer />} />
              <Route path="/invoice/:period/" element={<Invoice />} />
              <Route path="/management" element={<Management />} />
            </Route>
          </Routes>
        </Router>
      ) : (
        <Login />
      )}
    </>
  );
};

export default App;
